import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PaginationService } from './pagination.service';
import { Pagination, PaginationOnLoad } from './pagination';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false,
})
export class PaginationComponent implements OnInit {
  public pagination: Pagination;

  @Input() options: Pagination;
  @Output() onLoadPartial = new EventEmitter<PaginationOnLoad>();

  constructor(public paginationService: PaginationService) {}

  ngOnInit() {
    this.paginationService.subscribePaginationState().subscribe((state) => {
      this.pagination = state;
    });
  }

  public onChangePaginationLimit(limit: number) {
    this.paginationService.changeLimitSelected(limit);
  }

  public onLoadPartialHandler() {
    let paginationState = this.paginationService.getPaginationState();
    this.onLoadPartial.emit({
      offset: paginationState.offset,
      limit: paginationState.limitSelected,
    });
  }
}
